// Readonly is templates, which does not require rendering fields and only
// work based on the highlighted text
export const readOnlyTemplates = [
  { template: 'freeFormEditor', qualityTrackLabel: 'add more' },
  { template: 'freeFormEditorInstruct', qualityTrackLabel: 'request content' },
  { template: 'contentRewriter', qualityTrackLabel: 'rewrite your' },
  { template: 'contentImprover', qualityTrackLabel: 'enhance your' },
];
